import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import backButtonImg from '../../assets/backcircle.svg'
import closeImg from '../../assets/close.svg'
import coinImg from '../../assets/coin.svg'
import { scrubItemAssets } from '../../redux/designerReducers/assetsReducer'
import MembershipIcon from '../../assets/badge_membership_on.png'
import { formatMoney } from '../../utils/utils'
import {
  CarouselHeader,
  CarouselTitle,
  CarouselTitles,
  CommonFlex,
  FilterCard,
  FilterCardCanvas,
  FilterCardImage,
  FilterName,
  FilterPostContent,
  FiltersCarouselContainer,
  LoadingContainer,
  MobileBackButton,
  ModalFooter,
  ModalFooterInfo,
  ModalHeader,
  ModalHeaderClose,
  ModalHeaderCoin,
  ModalHeaderInfo,
  ModalTitle,
  PostView,
  SceneImg,
  ScrollableHorizontal,
  SubmitButton,
  UnlockButton,
  UnlockButtonContainer
} from './PostModalNew.styles'
import { setShowMembershipModal } from '../../redux/designerReducers/designerReducer'
import { LoadingIndicator2 } from '../Loading'
import { useIsMobile } from '../../hooks/useIsMobile'
import { getMembershipType } from '../../utils/getMembershipType'

export const PostFilters = ({
  onClose,
  selectedFilter,
  setSelectedFilter,
  isSending,
  onSubmitPost,
  handleBack
}) => {
  const dispatch = useDispatch()
  const designImage = useSelector(state => state.canvas.design)
  const numCoins = useSelector(state => state.profile.me.numCoins)
  const profile = useSelector(state => state.profile.me)
  const membershipInfo = getMembershipType(profile)
  const filtersFeed = useSelector(state => state.itemFeed.feed)
  const isMobile = useIsMobile()

  const handleSubmit = () => {
    if (selectedFilter !== null && !membershipInfo.isMember) {
      dispatch(setShowMembershipModal(true))
      return
    }

    onSubmitPost()
  }

  const selectedFilterImg = selectedFilter
    ? scrubItemAssets(selectedFilter)[0]?.original
    : null

  return (
    <>
      <ModalHeader withBackButton>
        <ModalTitle>
          <MobileBackButton
            onClick={handleBack}
            src={backButtonImg}
            alt="Back"
          />
          <span>Choose a Filter</span>
        </ModalTitle>
        <ModalHeaderInfo>
          Coin Balance: <ModalHeaderCoin src={coinImg} alt="" />{' '}
          {formatMoney(numCoins, 0)}
          <ModalHeaderClose
            onClick={onClose}
            src={closeImg}
            alt="Close modal"
          />
        </ModalHeaderInfo>
      </ModalHeader>
      <FilterPostContent>
        <PostView>
          <SceneImg src={designImage} alt="" />
          {selectedFilterImg && <SceneImg src={selectedFilterImg} alt="" />}
        </PostView>
      </FilterPostContent>
      <FiltersCarouselContainer filtersPanel>
        {!isMobile && (
          <CarouselHeader>
            <CarouselTitles>
              <CarouselTitle>Filters</CarouselTitle>
            </CarouselTitles>
          </CarouselHeader>
        )}
        <ScrollableHorizontal>
          <FilterCard
            selected={selectedFilter === null}
            onClick={() => {
              setSelectedFilter(null)
            }}
          >
            <FilterCardCanvas>
              <FilterCardImage src={designImage} alt="" />
            </FilterCardCanvas>
            <FilterName>None</FilterName>
          </FilterCard>
          {filtersFeed.map(filter => {
            const scrubbedAssets = scrubItemAssets(filter)

            const [filterImage] = scrubbedAssets

            if (!filterImage) return null

            return (
              <FilterCard
                selected={selectedFilter === filter}
                onClick={() => {
                  setSelectedFilter(filter)
                }}
                key={filter.objectId}
              >
                <FilterCardCanvas>
                  <FilterCardImage src={designImage} alt="" />
                  <FilterCardImage src={filterImage.original} alt="" />
                  <img
                    src={MembershipIcon}
                    width="15px"
                    height="15px"
                    loading="lazy"
                    alt=""
                    style={{
                      position: 'absolute',
                      top: isMobile ? 7 : 2,
                      right: 2
                    }}
                  />
                  {!membershipInfo.isMember && (
                    <UnlockButtonContainer>
                      <UnlockButton
                        onClick={() => {
                          dispatch(setShowMembershipModal(true))
                        }}
                      >
                        Unlock
                      </UnlockButton>
                    </UnlockButtonContainer>
                  )}
                </FilterCardCanvas>
                <FilterName>{filter.title}</FilterName>
              </FilterCard>
            )
          })}
        </ScrollableHorizontal>
      </FiltersCarouselContainer>
      <ModalFooter>
        <ModalFooterInfo />
        {!isSending && (
          <CommonFlex>
            <SubmitButton onClick={handleSubmit}>Post</SubmitButton>
          </CommonFlex>
        )}
        {isSending && (
          <LoadingContainer>
            <LoadingIndicator2 loading={true} />
          </LoadingContainer>
        )}
      </ModalFooter>
    </>
  )
}
